import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { Avatar, Button, Card, Col, Modal, Radio, Row, Select, Space, Spin } from 'antd';
import MemberProSvg from '../../assets/images/MemberProSvg';
import InputNumberComponent from '../../components/input/InputNumberComponent';
import DateComponent from '../../components/date/DateComponent';
import TextAreaComponent from '../../components/input/TextAreaComponent';
import UserProSvg from '../../assets/images/UserProSvg';
import EditSvg from '../../assets/images/EditSvg';
import HistorySvg from '../../assets/images/HistorySvg';
import { useLocation, useNavigate } from 'react-router-dom';
import TablePayment from './TablePayment';
import { getDataRequest, putDataRequest } from '../../api/serviceMethods';
import { MEMBER_SUBSCRIPTION_URL, MEMBER_URL } from '../../api/URLs';
import { formatDateUTC, formatDateTime } from '../../utils/dateFormatUtils';
import moment from 'moment';
import { differenceInDays, differenceInMonths, differenceInYears } from 'date-fns';
import HeaderDetailComponent from '../../components/header/headerDetailComponent';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import InputMask from 'react-input-mask';
import emptyImage from "../../assets/images/image.jpeg"
import MemberVIPSvg from '../../assets/images/MemberVIPSvg';
import InputComponent from '../../components/input/InputComponent';
import { validateEmail } from '../../utils/Validate';
import { renderMemberStatusBadge } from '../../utils/memberStatusUtils';

function MemberDetailPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [editPlanType, setEditPlanType] = useState('pro');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [btnDisable, setBtnDisable] = useState(false)
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false)
  const [userDetails, setUserDetails] = useState(null)
  const messageModalRef = useRef("");
  const [modalOpenNew, setModalOpenNew] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [isChange, setIsChange] = useState(false);
  let userDetailId = params.get('id');
  const [dataObj, setDataObj] = useState({
    setMembership: "manually",
    remark: "",
    manually: "",
    endTS: ""
  })

  const [dataObjectNew, setDataObjectNew] = useState({
    phone: {
      countryCode: "852",
      number: ""
    },
    email: ""
  });

  const onChange = (e) => {
    setDataObj((membership) => ({
      ...membership,
      setMembership: e.target.value,
    }));
  };

  useEffect(() => {
    const hasValue = Boolean(dataObj.setMembership === "manually" ? dataObj.manually : dataObj.endTS);
    const hasRemark = Boolean(dataObj.remark && dataObj.remark.trim());
    if (hasValue && hasRemark) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [dataObj]);

  const addNewValue = async (data) => {
    setDataObjectNew({
      phone: {
        countryCode: !data?.phone?.number ? "852" : `${data && data.phone && data.phone.countryCode}`,
        number: !data?.phone?.number ? "" : data && data.phone && data.phone.number,
      },
      email: data && data?.email
    })
  }

  useEffect(() => {
    setIsSubmit(false)
    addNewValue(userDetails && userDetails)
  }, [userDetails, modalOpenNew])

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    if (!dataObjectNew?.phone?.number && !dataObjectNew?.email || dataObjectNew?.email && !validateEmail(dataObjectNew?.email)) {
      return false;
    }
    try {
      const memberPayload = {
        phone: !dataObjectNew?.phone?.number ? null : {
          countryCode: dataObjectNew && dataObjectNew.phone && dataObjectNew.phone.countryCode,
          number: isChange && typeof dataObjectNew?.phone?.number === 'string'
            ? dataObjectNew.phone.number.replace(/[^0-9]/g, '')
            : dataObjectNew?.phone?.number || '',
        },
        email: dataObjectNew?.email ? dataObjectNew?.email : null
      }
      setLoading(true);
      await putDataRequest(`${MEMBER_URL}/${userDetailId} `, memberPayload)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            messageModalRef?.current?.showSuccessConfirmsAutoClose(t("Updated Successfully"), () => {
              setModalOpenNew(false)
            }, "", true);
            fetchUserDetails(userDetailId)
          } else {
            messageModalRef?.current?.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err)
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || err && err.message || "Server Error!", () => { }, "", true);
        });
    } catch (error) {
      console.log("error", error)
      setLoading(false);
    }
  }

  const fetchUserDetails = async (userDetailId) => {
    try {
      setLoading(true);
      const memberData = await getDataRequest(`${MEMBER_URL}/${userDetailId}`);
      if (memberData.status === 200) {
        setUserDetails(memberData && memberData?.data);
      }
    } catch (err) {
      console.error("Error fetching user details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDetailId) {
      fetchUserDetails(userDetailId);
    }
  }, [userDetailId]);

  function formatDuration(input) {
    if (!input) return "0天";
    const { y = 0, m = 0, d = 0 } = input;

    let parts = [];
    if (y > 0) parts.push(`${y}年`);
    if (m > 0) parts.push(`${m}个月`);
    if (d > 0) parts.push(`${d}天`);

    return parts.length > 0 ? parts.join(" ") : "0天";
  }

  const phoneData = [
    {
      label: "+852",
      value: "852"
    },
    {
      label: "+86",
      value: "86"
    }
  ]


  const handleUpdateMembership = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    if (!dataObj.remark || !dataObj.remark.trim()) {
      return false;
    }
    try {
      const targetPlan = editPlanType === "VIP" ? "super" : "pro";
      const baseExpiry = userDetails?.plans?.[targetPlan]?.endTS || new Date();

      let targetEndDateStr = "";
      if (dataObj.setMembership === "manually") {
        const daysToAdd = parseInt(dataObj.manually, 10) || 0;
        targetEndDateStr = moment.utc(baseExpiry).add(daysToAdd, 'days').format('YYYY-MM-DD');
      } else {
        targetEndDateStr = moment.utc(dataObj.endTS).format('YYYY-MM-DD');
      }

      const overridePayload = {
        memberId: userDetailId,
        plan: targetPlan,
        endDate: targetEndDateStr,
        reason: dataObj.remark.trim()
      };

      setLoading(true);
      await putDataRequest(`${MEMBER_SUBSCRIPTION_URL}/override`, overridePayload)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            messageModalRef.current.showSuccessConfirmsAutoClose(t("Updated Successfully"), () => { }, "", true);
            setTimeout(() => {
              setModalOpen(false);
              fetchUserDetails(userDetailId);
              setDataObj({
                setMembership: "manually",
                remark: "",
                manually: "",
                endTS: "",
              });
            }, 1000);
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || err && err.message || "Server Error!", () => { }, "", true);
        });
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const address = `${userDetails?.province || ""} ${userDetails?.city || ""}`.trim();
  useEffect(() => {
    if (modalOpenNew) {
      fetchUserDetails(userDetailId)
    }
  }, [modalOpenNew]);

  // Membership periods (source of truth from the backend): { startTS, endTS, duration } or null
  const freePlan = userDetails?.plans?.free || null;
  const proPlan = userDetails?.plans?.pro || null;
  const superPlan = userDetails?.plans?.super || null;
  const startOfToday = moment().startOf('day');
  const endOfToday = moment().endOf('day');
  const isLive = (p) => Boolean(p?.endTS && moment(p.endTS).isSameOrAfter(startOfToday));
  const isCovering = (p) => Boolean(isLive(p) && p?.startTS && moment(p.startTS).isSameOrBefore(endOfToday));
  // Hide an ended plan only while the other plan is the one covering today
  const showPro = Boolean(proPlan && (isLive(proPlan) || !isCovering(superPlan)));
  const showSuper = Boolean(superPlan && (isLive(superPlan) || !isCovering(proPlan)));
  const editPlan = editPlanType === "VIP" ? superPlan : proPlan;

  return (
    <HeaderDetailComponent
      bntTitle={t('Modify Information')}
      backgroundColor="#f8e2e8"
      border="1px solid #e72158"
      isHide="view"
      onClick={() => navigate('/member')}
      backTitle={t("Membership Details")}
      hideTitle="userDetails"
      setModalOpenNew={setModalOpenNew}
    >
      <Spin spinning={loading}>
        <div className='container newDetail'>
          <p className='userTitle'>{t("Basic Information")}</p>
          <Card style={{ width: "100%" }}>
            <Row align="middle" gutter={[16, 16]}>
              <Col>
                <Avatar
                  src={userDetails && userDetails.picUrl ? userDetails.picUrl : emptyImage}
                  style={{
                    height: "48px",
                    width: "48px"
                  }}
                />
              </Col>
              <Col>
                {renderMemberStatusBadge(userDetails, t)}
              </Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('User Id')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.memberId}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('Phone Number')}:</Col>
              <Col className="text-capitalize">{!userDetails?.phone?.number ? "N/A" : <>{`+${userDetails?.phone?.countryCode}`} {userDetails?.phone?.number}</>}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('employee_email')}:</Col>
              <Col className="">{userDetails && userDetails.email ? userDetails && userDetails.email : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('fullName')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.name ? userDetails && userDetails.name : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('gender')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.sex ? t(userDetails && userDetails.sex) : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('address')}:</Col>
              <Col className="text-capitalize">{address ? address : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('user category')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.category ? t(userDetails && userDetails.category) : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('Register Time')}:</Col>
              <Col className="text-capitalize">{userDetails && formatDateTime(userDetails.createdTS)}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('Last Login Time')}:</Col>
              <Col className="text-capitalize">{userDetails && formatDateTime(userDetails.lastLogin)}</Col>
            </Row>
          </Card>

          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
            <p className='userTitle pt-3'>{t("Member Information")}</p>
            <div style={{ cursor: "pointer" }} title={t("Member History")} onClick={() => navigate(`/membership/details?id=${userDetailId && userDetailId}`)}><HistorySvg /></div>
          </div>
          {showPro || showSuper ? (
            <Row gutter={[16, 16]}>
              {showPro && (
                <Col span={showSuper ? 12 : 24}>
                  <Card style={{ width: "100%", height: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                      {/* <MemberProSvg /> */}
                      {t("Normal Member")}
                    </div>
                    <Row align="middle">
                      <Col span={13} className='userLabel'>{t('Membership trial time')}:</Col>
                      <Col span={11} className="text-capitalize">{proPlan.startTS ? formatDateUTC(proPlan.startTS) : "N/A"}</Col>
                    </Row>
                    <Row align="middle" className='mt-3'>
                      <Col span={13} className='userLabel'>{t('Membership expired date')}:</Col>
                      <Col span={11} className="text-capitalize">
                        {proPlan.endTS ? formatDateUTC(proPlan.endTS) : "N/A"}
                        <span
                          style={{ cursor: "pointer", marginLeft: "8px" }}
                          onClick={() => {
                            setEditPlanType('pro');
                            setModalOpen(true);
                          }}
                        >
                          <EditSvg />
                        </span>
                      </Col>
                    </Row>
                    <Row align="middle" className='mt-3'>
                      <Col span={13} className='userLabel'>{t('Membership Period')}:</Col>
                      <Col span={11} className="text-capitalize">
                        {formatDuration(proPlan.duration)}
                      </Col>
                    </Row>
                  </Card>
                </Col>
              )}
              {showSuper && (
                <Col span={showPro ? 12 : 24}>
                  <Card style={{ width: "100%", height: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                      <MemberVIPSvg />
                    </div>
                    <Row align="middle">
                      <Col span={13} className='userLabel'>{t('Membership trial time')}:</Col>
                      <Col span={11} className="text-capitalize">{superPlan.startTS ? formatDateUTC(superPlan.startTS) : "N/A"}</Col>
                    </Row>
                    <Row align="middle" className='mt-3'>
                      <Col span={13} className='userLabel'>{t('Membership expired date')}:</Col>
                      <Col span={11} className="text-capitalize">
                        {superPlan.endTS ? formatDateUTC(superPlan.endTS) : "N/A"}
                        <span
                          style={{ cursor: "pointer", marginLeft: "8px" }}
                          onClick={() => {
                            setEditPlanType('VIP');
                            setModalOpen(true);
                          }}
                        >
                          <EditSvg />
                        </span>
                      </Col>
                    </Row>
                    <Row align="middle" className='mt-3'>
                      <Col span={13} className='userLabel'>{t('Membership Period')}:</Col>
                      <Col span={11} className="text-capitalize">
                        {formatDuration(superPlan.duration)}
                      </Col>
                    </Row>
                  </Card>
                </Col>
              )}
            </Row>
          ) : (
            <Card style={{ width: "100%" }}>
              <Row align="middle">
                <Col span={6} className='userLabel'>{t('Membership Type')}:</Col>
                <Col className="text-capitalize">
                  {userDetails?.memberType === "trial" ? t("Free trial") : t("No membership")}
                </Col>
              </Row>
              <Row align="middle" className='mt-3'>
                <Col span={6} className='userLabel'>
                  {freePlan ? t('Free trial start time') : t('Member Activation Time')}:
                </Col>
                <Col className="text-capitalize">
                  {freePlan?.startTS
                    ? formatDateUTC(freePlan.startTS)
                    : userDetails?.activatedTS
                      ? formatDateUTC(userDetails.activatedTS)
                      : "N/A"}
                </Col>
              </Row>
              <Row align="middle" className='mt-3'>
                <Col span={6} className='userLabel'>
                  {freePlan ? t('Free trial end time') : t('Member Expiration Time')}:
                </Col>
                <Col className="text-capitalize">
                  {freePlan?.endTS ? formatDateUTC(freePlan.endTS) : "N/A"}
                </Col>
              </Row>
            </Card>
          )}

          <p className='userTitle pt-3'>{t("Payment History")}</p>
          <Card style={{ width: "100%", marginBottom: "2rem" }}>
            <TablePayment userDetailId={userDetailId} />
          </Card>
        </div>

        <Modal
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UserProSvg />
              <span style={{ marginLeft: "10px" }}>{t('Manually Activate Membership')}</span>
            </div>
          }
          centered
          width={700}
          open={modalOpen}
          className='custom-modal'
          onOk={() => setModalOpen(false)}
          onCancel={() => {
            setModalOpen(false)
            setDataObj({
              setMembership: "manually",
              remark: "",
              manually: "",
              endTS: "",
            });
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
          okButtonProps={{ style: { display: "none" } }}
        >
          <Row className='d-flex align-items-center' style={{ paddingLeft: "80px", paddingTop: "20px", paddingBottom: "15px" }}>
            <Col md={3}>
              <Avatar
                src={userDetails && userDetails.picUrl ? userDetails.picUrl : emptyImage}
                style={{
                  height: "60px",
                  width: "60px"
                }}
              />
            </Col>
            <Col md={16}>
              <Row>
                <Col md={24}>{editPlanType === "VIP" ? <MemberVIPSvg /> : <MemberProSvg />}</Col>
                <div className='mt-2 d-flex'>
                  <div className='d-flex col-6'>
                    <div className='userLabel'>{t('User Id')}:</div>
                    <div style={{ marginLeft: "20px" }}>{userDetails && userDetails.memberId}</div>
                  </div>
                  <div style={{ marginLeft: "60px" }} className='d-flex col-6'>
                    <div className='userLabel'>{t('Membership Period')}:</div>
                    <div style={{ marginLeft: "20px" }}>
                      {formatDuration(editPlan?.duration)}
                    </div>
                  </div>
                </div>
              </Row>
            </Col>
          </Row>
          <div className='mt-3' style={{ borderTopColor: "#636E88", borderTopStyle: "dashed", borderTopWidth: "1.5px", height: "20px" }}></div>
          <Row style={{ paddingLeft: "80px", paddingTop: "20px", paddingBottom: "15px", paddingRight: "70px" }}>
            <Col md={7}>{t('To manually set the membership period')}:</Col>
            <Col md={14} style={{ marginTop: "-8px" }}>
              <Row>
                <Col md={24}>
                  <Radio.Group onChange={onChange} value={dataObj.setMembership}>
                    <Space direction="vertical">
                      <Radio value="manually" style={{ width: "150px" }}><InputNumberComponent disabled={dataObj.setMembership === "endTS" ? true : false} value={dataObj.manually} setValue={(value) => setDataObj({ ...dataObj, manually: value })} style={{ width: "100px", marginLeft: "10px" }} placeholder={t('Please select the number of days')} /></Radio>
                      <Radio value="endTS" className='mt-3'><DateComponent format="YYYY-MM-DD" minDate={editPlan?.startTS ? moment.utc(editPlan.startTS).format('YYYY-MM-DD') : null} disabled={dataObj.setMembership === "manually" ? true : false} value={dataObj.endTS} setValue={(value) => setDataObj({ ...dataObj, endTS: value })} style={{ width: "200px", marginLeft: "10px" }} placeholder={t("Please select the time period")} /></Radio>
                    </Space>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col md={3} style={{ marginLeft: "-130px" }}>{t("day")}</Col>
            <Col md={7} className='mt-4'>
              <span><span style={{ color: "#e50a47" }}>* </span>{t('Remark')} ({t('reason_saved_to_history')}):</span>
            </Col>
            <Col md={17} className='mt-4'>
              <Col md={24}>
                <TextAreaComponent placeholder={t('enter_reason_manual_override')} value={dataObj.remark} setValue={(value) => setDataObj({ ...dataObj, remark: value })} />
              </Col>
            </Col>
          </Row>
          <div className='d-flex justify-content-center mt-3'>
            <Button
              disabled={btnDisable ? false : true}
              style={{
                backgroundColor: "#E50A47",
                border: "none",
                color: "White",
                height: "45px",
                width: "230px",
                margin: "auto",
                borderRadius: "10px",
                fontSize: "16px",
                fontWeight: 500,
                opacity: btnDisable ? 1 : 0.5
              }}
              onClick={handleUpdateMembership}
            >
              {t("Confirm Submit")}
            </Button>
          </div>
        </Modal>
      </Spin>
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* <UserProSvg /> */}
            <span style={{ marginLeft: "10px" }}>{t('Edit Basic Info')}</span>
          </div>
        }
        centered
        width={700}
        open={modalOpenNew}
        className='custom-modal'
        onOk={() => setModalOpenNew(false)}
        onCancel={() => setModalOpenNew(false)}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: "none" } }}
      >
        <Spin spinning={loading}>
          <Row className='mt-3 d-flex align-items-center' style={{ padding: "10px" }}>
            <Col md={4}>
              <div>
                <label htmlFor=''>{t('Phone Number')}</label>
              </div>
            </Col>
            <Col md={20} className='d-flex'>
              <Select
                className="selectCus"
                value={dataObjectNew.phone.countryCode}
                size="large"
                style={{
                  width: 100,
                }}
                onChange={(value) => setDataObjectNew({
                  ...dataObjectNew,
                  phone: {
                    ...dataObjectNew.phone,
                    countryCode: value,
                  },
                })}
                options={phoneData}
              />
              <InputMask
                key={dataObjectNew.phone.countryCode}
                value={dataObjectNew.phone.number}
                onChange={(event) => {
                  setDataObjectNew({
                    ...dataObjectNew,
                    phone: {
                      ...dataObjectNew.phone,
                      number: event.target.value,
                    }
                  });
                  setIsChange(true);
                }}
                className={`inputCustomPho ${isSubmit && !dataObjectNew.phone.number && !dataObjectNew?.email || !dataObjectNew.phone.number && !dataObjectNew?.email ? 'input-error-cus' : ''}`}
                mask={dataObjectNew.phone.countryCode === "852" ? "9999-9999" : "999-9999-9999"}
              />
            </Col>
          </Row>
          <Row className='mt-1 d-flex align-items-center' style={{ padding: "10px" }}>
            <Col md={4}>
              <div>
                <label htmlFor=''>{t('employee_email')}</label>
              </div>
            </Col>
            <Col md={20} className='d-flex'>
              <InputComponent className={`mb-2`} status={isSubmit && !validateEmail(dataObjectNew?.email) || !dataObjectNew.phone.number && !dataObjectNew?.email ? `error` : ''} value={dataObjectNew.email}
                setValue={(value) => setDataObjectNew({ ...dataObjectNew, email: value })} placeholder="" />
            </Col>
          </Row>
          <div className='text-center pt-3'>
            <Button
              style={{
                backgroundColor: "#e50a47",
                color: "white",
                height: "45px",
                width: "230px",
                fontWeight: 500,
                border: "none",
                fontSize: "16px"
              }}
              onClick={handleUpdate}
            >
              {t('update')}
            </Button>
          </div>
        </Spin>
      </Modal>
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </HeaderDetailComponent>
  );
}

export default MemberDetailPage;
